export default __webpack_public_path__ + "static/media/web_development.04227a5f.jpeg";